const blackpanthertriviaTNC = {
  header: "BLACK PANTHER TRIVIA TERMS",
  body: [
    {
      title: "GENERAL TERMS",
      details: `The Movie ticket Trivia targets only Pulse Users with Smartphones`,
    },
    {
      title: ``,
      details: `As a digital oriented promo, there will be no opt in by way of USSD channel. All Smartphone customers on MTN Pulse qualify to participate in the trivia`,
    },
    {
      title: "",
      details: `Pulse Users within locations near the Accra Mall will be eligible to proceed with the Trivia.`,
    },
    {
      title: "",
      details: `Eligible Customers are to answer five (5) questions correct to be able to access a ticket for the Premiere.`,
    },
    {
      title: ``,
      details: `All Customers that are within the locations near the Accra mall that participates in the Trivia have up to three chances of attempting to answer the Trivia.`,
    },
    {
      title: ``,
      details: `Customer will receive an In-App notification of winning a ticket with a code for the Premiere.`,
    },
    {
      title: ``,
      details: `Ticket can be used to view only Black Panther Movie Premiere.`,
    },
    {
      title: ``,
      details: `Ticket can be used at the Silverbird Cinemas Accra Mall only.`,
    },
    {
      title: ``,
      details: `Trivia starts from 1st to 5th November, 2022`,
    },
    {
      title: ``,
      details: `Ticket is valid until November 11, 2022.`,
    },
    {
      title: ``,
      details: `Ticket admits two (2) persons.`,
    },
    {
      title: ``,
      details: `Regular Movie Mania Tickets cannot be used to view Black Panther Movie Premiere.`,
    },
    {
      title: ``,
      details: `SIMs dedicated solely for commercial transactions by Mobile Money merchants are exempted from this promotion.`,
    },
    {
      title: ``,
      details: `MTN Staff and their spouses as well as third party agents are exempted from this Trivia.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to disqualify a winner when it is proven that the winner used any fraudulent means to participate in the Trivia. Such customers will be handed over to the pólice to face the law.`,
    },
    {
      title: ``,
      details: `Trivia duration can be extended whenever MTN deems it appropriate.`,
    },
    {
      title: ``,
      details: `All customers outside the locations around the Accra Mall who attempts to undertake the Trivia will be disqualified from participating.`,
    },
    {
      title: ``,
      details: `Personal customer information of partcipants will not be published publicly in line with data privacy and protection.`,
    },
    {
      title: ``,
      details: `Winners will be notified only by MTN authorized personnel and via the number 0244 300 000`,
    },
  ],
};

export default blackpanthertriviaTNC;
